module.exports = __webpack_public_path__ + "static/media/PM14.b83e167d.png";